<script setup lang="ts">
import type { NuxtError } from '#app'
import { useLogger } from './composables/useLogger'

const props = defineProps({
  error: {
    type: Object as PropType<NuxtError>,
    required: true
  }
})

const logger = useLogger()

// Log the error when the error page is shown
onMounted(() => {
  logger.handleError(props.error, 'Global Error Boundary - page logging')
})

useSeoMeta({
  title: 'Error Occurred',
  description: 'We are sorry but an error has occurred.'
})
</script>

<template>
  <div>
    <UMain>
      <UContainer>
        <UPage>
          <UPageError :error="error" />
        </UPage>
      </UContainer>
    </UMain>
    <UNotifications />
  </div>
</template>
